import "toastr/build/toastr.min.css";
import toastr from "toastr";

toastr.options = {
    closeButton: true,
    timeOut: 3000
};

function success(message, timeOut) {
    if (timeOut !== undefined) toastr.options.timeOut = timeOut;
    toastr.success(message);
}

function info(message, timeOut) {
    if (timeOut !== undefined) toastr.options.timeOut = timeOut;
    toastr.info(message);
}

function warn(message, timeOut) {
    if (timeOut !== undefined) toastr.options.timeOut = timeOut;
    toastr.warning(message);
}

function error(message, timeOut) {
    if (timeOut !== undefined) toastr.options.timeOut = timeOut;
    toastr.error(message);
}

const notificationService = {
    success: success,
    info: info,
    warn: warn,
    error: error
};

export const services = {
    notificationService: notificationService
};